module.exports = __webpack_public_path__ + "static/moonamar-aceite-de-comino-negro-organico-250-ml-bio-e5fbdd512432ec65a2ba5d0ac4259b8f.png";